/*
 * @Author: Ryan
 * @Date: 2026-03-11
 * @Description: Explore More section - pill-style tag links to other AI tools
 */
import Link from 'next/link';
import React from 'react';

import {
  aiVideoEditURL,
  avatarVideoProURL,
  faceSwapperURL,
  imageGenerateURL,
  productAvatarURL,
  videoGenerateURL,
  videoTranslateURL,
  voiceCloneURL,
} from '@/utils/routeConstants';

export interface ToolTag {
  title: string;
  link: string;
}

const defaultTools: ToolTag[] = [
  { title: 'AI Video Generator', link: videoGenerateURL },
  { title: 'AI Video Translator', link: videoTranslateURL },
  { title: 'AI Avatar Generator', link: avatarVideoProURL },
  { title: 'AI Image Generator', link: imageGenerateURL },
  { title: 'AI Product Avatar', link: productAvatarURL },
  { title: 'Face Swap', link: faceSwapperURL },
  { title: 'AI Voice Cloning', link: voiceCloneURL },
  { title: 'AI Video Editor', link: aiVideoEditURL },
];

export interface ExploreToolsSectionProps {
  tools?: ToolTag[];
}

const ExploreToolsSection: React.FC<ExploreToolsSectionProps> = ({ tools }) => {
  return (
    <section className="w-full py-12 pad:py-16 sm:py-20 px-4 pad:px-8 sm:px-[65px]">
      <div className="max-w-[1190px] mx-auto">
        <h2 className="text-2xl pad:text-3xl sm:text-4xl font-bold text-[#0F1117] text-center mb-8 pad:mb-10 sm:mb-12">
          Explore More
        </h2>

        <div className="flex flex-wrap justify-center gap-3 pad:gap-4">
          {(tools || defaultTools).map((tool, index) => (
            <Link
              key={tool.link}
              href={tool.link}
              className={`inline-flex items-center justify-center px-6 py-3 pad:px-8 pad:py-3.5 text-sm pad:text-base font-medium rounded-lg border transition-all duration-200 hover:border-[#1a1145] hover:text-[#1a1145] ${
                index === 0
                  ? 'border-[#1a1145] text-[#1a1145]'
                  : 'border-gray-200 text-[#0F1117]'
              }`}
            >
              {tool.title}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExploreToolsSection;
